// ItemIdentity - enforces the app-wide Item No / Cat No display rule.
// Hire's primary identifier is itemNo; catNo is the secondary value.
//   roomy  -> "ItemNo (CatNo)"   (cards, headers, detail rows, option rows)
//   tight  -> "ItemNo" only        (chips, dense single-line cells)
// Never renders blank: falls back to whichever of itemNo / catNo exists.
// ItemNo renders in mono (the load-bearing "scannable identifier" convention).
//
//   <ItemIdentity item={row} roomy />          // ITM-04821 (CAT-7750-LH)
//   <ItemIdentity itemNo="ITM-04821" />         // tight -> ITM-04821
//   <ItemIdentity item={r} size="block" roomy />

import React from 'react';
import { itemPrimaryLabel, itemFullLabel } from '../../shared';

export default function ItemIdentity({
  item,
  itemNo,
  catNo,
  roomy = false,
  size = 'inline', // 'inline' | 'block'
  idStyle,
  catStyle,
  style,
  ...rest
}) {
  const a = item || { itemNo, catNo };
  const id = itemPrimaryLabel(a); // itemNo (fallback catNo)
  const full = itemFullLabel(a); // "itemNo (catNo)"
  const hasBoth = full.includes('(');

  if (size === 'block') {
    const catOnly = hasBoth ? full.slice(full.indexOf('(')) : null;
    return (
      <span style={{ display: 'inline-flex', flexDirection: 'column', ...style }} {...rest}>
        <span className="app-mono" style={{ fontWeight: 600, color: 'var(--text)', lineHeight: 1.15, ...idStyle }}>
          {id}
        </span>
        {roomy && catOnly && (
          <span className="app-mono" style={{ fontSize: '0.62em', color: 'var(--faint)', lineHeight: 1.2, ...catStyle }}>
            {catOnly}
          </span>
        )}
      </span>
    );
  }

  if (roomy && hasBoth) {
    const idPart = full.slice(0, full.indexOf('(')).trim();
    const catPart = full.slice(full.indexOf('('));
    return (
      <span className="app-mono" style={{ display: 'inline-flex', alignItems: 'baseline', gap: 6, ...style }} {...rest}>
        <span style={{ fontWeight: 600, color: 'var(--text)', ...idStyle }}>{idPart}</span>
        <span style={{ color: 'var(--faint)', fontSize: '0.82em', ...catStyle }}>{catPart}</span>
      </span>
    );
  }

  return (
    <span className="app-mono" style={{ fontWeight: 600, color: 'var(--text)', ...style, ...idStyle }} {...rest}>
      {id}
    </span>
  );
}
